<div class="group/tooltip relative">
  <div class="hidden absolute z-50 left-1/2 min-w-min w-max max-w-xs py-2 px-4 bg-gray-1100 rounded-lg transform -translate-x-1/2 shadow group-hover/tooltip:block" [ngClass]="{ 'bottom-full mb-3': position === 'top', 'top-full mt-3': position === 'bottom' }">
    <p class="relative z-10 text-sm text-white">{{ title }}</p>
    <div class="absolute left-1/2 w-6 h-6 bg-gray-1100 transform -translate-x-1/2 rotate-45" [ngClass]="{ 'top-full -mt-5': position === 'top', 'bottom-full -mb-5': position === 'bottom' }"></div>
  </div>
  <ng-content></ng-content>
</div>
